// Module
var code = " <div [ghGridCellTooltip]=\"message\" matTooltipPosition=\"below\" matTooltipClass=\"editable-cell-tooltip\"> <ng-content></ng-content> </div>";
// Exports
module.exports = code;